module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e20-d9e9f7c6510df6342ff76d1a9c02aa7d.jpg";